<script setup lang="ts">
import { defineProps } from 'vue';
import IconButton from './common/IconButton.vue';
import Menu_points from './icons/MenuPoints.vue';
import Dropdown from './common/Dropdown/Dropdown.vue';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import ProPlanLogo from '@/dashboard/vue/components/icons/ProPlanLogo.vue';

const props = withDefaults(
  defineProps<{
    title: string;
    showMenu: boolean;
    showProLogo?: boolean;
  }>(),
  {
    showProLogo: false,
  }
);
</script>

<template>
  <div
    class="laptop:rounded-zero inline-flex w-full flex-col rounded-16 bg-white shadow-x dark:bg-gray-950 laptop:w-auto laptop:bg-transparent laptop:shadow-none dark:laptop:bg-transparent"
  >
    <div class="flex w-full flex-col items-center justify-start px-s laptop:h-xxl laptop:flex-row laptop:px-zero">
      <div class="flex h-[56px] w-full items-center justify-between laptop:h-auto laptop:w-auto">
        <div class="flex flex-row items-center">
          <ProPlanLogo v-if="props.showProLogo" class="mr-[12px]" />

          <span class="block max-w-[82vw] truncate text-[20px] text-black dark:text-gray-500 laptop:max-w-[50vw]">
            {{ props.title }}
          </span>
        </div>

        <Dropdown v-if="props.showMenu" class="ml-xs hidden laptop:block" body-class="mt-[1px] gap-[2px] p-[6px]">
          <template #title="{ isOpen }: any">
            <IconButton ref="open_theme_changer_btn" :shadow="false" :active="isOpen">
              <menu_points />
            </IconButton>
          </template>
          <template #body>
            <slot name="menu-body"></slot>
          </template>
        </Dropdown>
      </div>

      <span class="mx-[14px] hidden text-[14px] text-black dark:text-gray-500 laptop:inline">/</span>
      <Divider class="w-full laptop:hidden" />

      <slot name="components"></slot>
    </div>

    <div class="divider-panel hidden h-[1px] laptop:block" />
  </div>
</template>
